module.exports = __webpack_public_path__ + "media/assets/icons/choicepoint-img2-29ef993a5fe6482b5a4805c0f0006126.svg";